import track from './eventTracker';
import imageActionNames from './imageActionNames';

const CML = new (function () {
  const CML_PROPS = {
    item_event: 'cml.item',
    order_event: 'cml.order',
    index_event: 'cml.home',
    item_page: 'pdp',
    order_page: 'complete_my_looks_order_page',
    index_page: 'complete_my_looks_home_page',
    click: 'click',
    view: 'view',
    outfit_view: 'outfit_view',
    source: 'shop-your-looks',
    order_type: 'buy_now',
  };

  this.trackPageView = (outfits, collection) => {
    return track({
      event_name: CML_PROPS.index_event,
      canonical_name: CML_PROPS.index_page,
      action_type: CML_PROPS.view,
      action_name: 'page_view',
      collection,
      outfits,
    });
  };

  // Fires when an outfit comes into viewport on index page
  this.trackOutfitViewEvent = (outfitId, collection) => {
    return track({
      event_name: CML_PROPS.index_event,
      canonical_name: CML_PROPS.index_page,
      action_type: CML_PROPS.view,
      action_name: 'outfit_view',
      outfit_id: outfitId,
      collection,
      source: CML_PROPS.source,
    });
  };

  this.trackPDPViewEvent = ({
    outfitId,
    skuId,
    externalProductId,
    collection,
    outOfStock,
    limitedStock,
    relatedItemsSkuIds,
    source,
    hideItemLinkShown,
    subSource,
  }) => {
    return track({
      event_name: CML_PROPS.item_event,
      canonical_name: CML_PROPS.item_page,
      action_type: CML_PROPS.view,
      action_name: 'pdp_view',
      outfit_id: outfitId,
      sku_id: skuId,
      external_product_id: externalProductId,
      collection,
      source,
      sub_source: subSource,
      related_item_sku_ids: relatedItemsSkuIds,
      on_screen: {
        limited_stock: limitedStock,
        out_of_stock: outOfStock,
        hide_item: hideItemLinkShown,
      },
    });
  };

  this.trackColorEvent = (
    outfitId,
    skuId,
    source,
    collection,
    externalProductId,
  ) => {
    if (!outfitId || !skuId) {
      return null;
    }

    return track({
      event_name: CML_PROPS.item_event,
      canonical_name: CML_PROPS.item_page,
      action_type: CML_PROPS.click,
      action_name: 'selected_color',
      outfit_id: outfitId,
      sku_id: skuId,
      external_product_id: externalProductId,
      source,
      collection,
    });
  };

  this.trackImageViewEvent = (
    outfitId,
    skuId,
    externalProductId,
    imageKey,
    source,
    collection,
  ) => {
    // image.key is defined as `${image.category}-${i}` in ProductImageGallery
    // imageActionNames sorts action names by image.category
    const imageCategory = imageKey.split('-')[0].toLowerCase();
    const actionName = imageActionNames[imageCategory];

    const event = {
      event_name: CML_PROPS.item_event,
      canonical_name: CML_PROPS.item_page,
      action_type: CML_PROPS.view,
      action_name: actionName,
      outfit_id: outfitId,
      sku_id: skuId,
      external_product_id: externalProductId,
      source,
      collection,
    };

    return track(event);
  };

  this.trackBuyNowEvent = ({
    outfitId,
    collection,
    skuId,
    externalProductId,
    relatedItemSkuIds,
    source,
    subSource,
  }) => {
    track({
      event_name: CML_PROPS.item_event,
      canonical_name: CML_PROPS.item_page,
      action_type: CML_PROPS.click,
      action_name: 'buy_now',
      outfit_id: outfitId,
      sku_id: skuId,
      external_product_id: externalProductId,
      collection,
      related_item_sku_ids: relatedItemSkuIds,
      source,
      order_type: CML_PROPS.order_type,
      sub_source: subSource,
    });
  };
})();

export default CML;
